import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  connect() { this.sync() }

  sync() {
    this.toggleTarget.setAttribute("aria-expanded", String(this.element.open))
    const action = this.element.open ? "Zavřít hlavní nabídku" : "Otevřít hlavní nabídku"
    const unreadCount = this.toggleTarget.querySelector("[data-unread-message-count]")?.textContent.trim()
    const unreadLabel = unreadCount ? `, nepřečtené konverzace: ${unreadCount}` : ""
    this.toggleTarget.setAttribute("aria-label", `${action}${unreadLabel}`)
  }

  close(event) {
    if (!this.element.open) return
    event?.preventDefault()
    this.reset()
    this.toggleTarget.focus()
  }

  reset() {
    this.element.open = false
    this.sync()
  }

  navigate(event) {
    if (event.target.closest("a")) this.reset()
  }

  focusChanged(event) {
    if (this.element.open && !this.element.contains(event.target)) this.reset()
  }
}
